import React, { FC } from 'react'
import { cn } from 'design-system'
import { buttonVariants } from 'design-system'

import { networkUrl } from 'src/lib/util/network'

interface VisitBoardButtonProps {
  networkName: string
  boardId: string
  isBoardFollower: boolean
  boardJoined: boolean
}

export const VisitBoardButton: FC<VisitBoardButtonProps> = ({
  networkName,
  boardId,
  isBoardFollower,
  boardJoined
}) => {
  const boardHref = networkUrl(networkName, `/community/${boardId}`)

  return (
    <a
      href={boardHref}
      className={cn(buttonVariants({ buttonType: 'primary' }), {
        explode: !isBoardFollower,
        'explode--action': boardJoined
      })}>
      Visit Community
    </a>
  )
}
